import React, { useCallback, useState } from "react";
import { useHistory, Route, Switch, useRouteMatch } from "react-router-dom";
import LeftBar from "../../../components/left-bar/LeftBar";
import NavigationLinks from "../../../components/navigation-links/NavigationLinks";
import {getExportsSqlDocsForTable, navLinks} from "../../../services/settings";
import Content from "../../../components/content/Content";
import DataTable from "../../../components/data-table/DataTable";
import ActionButton from "../../../components/button/ActionButton";

function ExportsPage() {
    const history = useHistory();
    const { path } = useRouteMatch();
    const [refreshTable] = useState(false);

    const columnData = [
        { id: "name", label: "Название" },
        { id: "description", label: "Описание" },
    ];

    const handleCreateExport = useCallback(() => {
        history.push({
            pathname: `/settings/export/view/create`,
        });
    }, [history]);

    const exports = useCallback((...params) => {
        return getExportsSqlDocsForTable(...params);
    }, []);

    return (
        <React.Fragment>
            <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                <ActionButton onClick={handleCreateExport}>Создать</ActionButton>
            </LeftBar>
            <Content title="Exports">
                <Switch>
                    <Route exact path={path}>
                        <DataTable
                            columnData={columnData}
                            dataFunc={exports}
                            selector={false}
                            refresh={refreshTable}
                            linkTemplate={(item) => `/settings/export/view/${item.id}`}
                        />
                    </Route>
                </Switch>
            </Content>
        </React.Fragment>
    );
}

export default ExportsPage;